/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = true;




//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_library.js
// module id = 146
// module chunks = 60